import Colors, { blend } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const MapClusterTheme = {
    mapCluster: {
        light: {
            enabled: {
                backgroundColor: Colors.ironGrey,
                color: Colors.white,
            },
            hover: {
                backgroundColor: blend(Colors.ironGrey, Colors.white, Opacities.xLow),
            },
        },
        dark: {
            enabled: {
                backgroundColor: Colors.greyNurse,
                color: Colors.black,
            },
            hover: {
                backgroundColor: blend(Colors.greyNurse, Colors.black, Opacities.xLow),
            },
        },
    },
};
export default MapClusterTheme;
